'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _Object$assign = _interopDefault(require('babel-runtime/core-js/object/assign'));
var $ = _interopDefault(require('jquery'));
var A11y = _interopDefault(require('../global/a11y-helpers.js'));
var Config = _interopDefault(require('../global/config.js'));
var keyCodes = _interopDefault(require('../global/keycodes.js'));
var Accordion = _interopDefault(require('./accordion.js'));
require('./jquery.preparetransition.js');

/**
 * Slide-out drawer element
 * @param {string} id ID of drawer element
 * @param {string} position which direction drawer slides out from ("right" or "left")
 * @param {object} [options] optional configuration object
 * @param {string} [options.close='.js-drawer-close'] selector for element to trigger drawer close on click
 * @param {string} [options.open='.js-drawer-open-' + position] selector for element to trigger drawer open on click
 * @param {string} [options.openClass='js-drawer-open']  class applied to body element when drawer is open.
 * @param {string} [options.dirOpenClass='js-drawer-open' + position] class applied to body element when drawer is open indicating position of drawer.
 * @class Drawers
 * @namespace ShopifyMarketing
 * @constructor
*/
function Drawer(id, position, options) {
  var defaults = {
    close: '.js-drawer-close',
    open: '.js-drawer-open-' + position,
    openClass: 'js-drawer-open',
    dirOpenClass: 'js-drawer-open-' + position
  };

  this.$drawer = $('#' + id);

  if (!this.$drawer.length) {
    return false;
  }

  this.config = _Object$assign({}, defaults, options);
  this.position = position;
  this.drawerIsOpen = false;
  this.drawerHasOpened = false;
  this.$nodes = {
    parent: $('body, html'),
    page: $('#PageContainer'),
    accordion: $('#DrawerNavPrimaryAccordion'),
    secondaryAccordion: $('#DrawerNavSecondaryAccordion')
  };

  this.init();
}

Drawer.prototype.init = function () {
  if (this.$nodes.accordion.length) {
    this.accordion = new Accordion(this.$nodes.accordion, {
      mobileOnly: false,
      openFirst: false,
      itemSelector: '.accordion-item'
    });
  }

  if (this.$nodes.secondaryAccordion.length) {
    this.secondaryAccordion = new Accordion(this.$nodes.secondaryAccordion, {
      mobileOnly: false,
      openFirst: false,
      itemSelector: '.accordion-item'
    });
  }

  this.$drawer.on('keydown', this._onKeyDown.bind(this)).on('click', this._onClick.bind(this));

  $(this.config.open).on('click', this.open.bind(this));

  this.$drawer.find(this.config.close).on('click', this.close.bind(this));
};

/**
 * Open drawer
 * @method open
 * @param {Event} [evt] event object returned from event handler
 * @param {function} [evt.stopPropagation] event object returned from event handler
*/
Drawer.prototype.open = function (evt) {
  var _this = this;

  // Without this, the drawer opens, the click event bubbles up to $nodes.page
  // which closes the drawer.
  if (evt && evt.stopPropagation) {
    evt.stopPropagation();
    // save the source of the click, we'll focus to this on close
    this.$activeSource = $(evt.currentTarget);
  }

  if (this.drawerIsOpen || Config.get('drawerIsOpen', false)) {
    this.close();
    return;
  }

  // First check if there's an accordion instance in the drawer,
  // then check if drawer hasn't been opened once before,
  // finally, check if there are actual accordions to open
  if (this.accordion && this.drawerHasOpened === false && this.accordion.$accordionContents.length) {
    // If another accordion link has an active class, open it first
    // otherwise, open the first accordion in the drawer
    var activeItem = this.$nodes.accordion.find(this.accordion.config.itemLink + '.drawer__item--active');

    if (activeItem.length) {
      // Open the active accordion with no animation
      this.accordion.toggle(activeItem.closest(this.accordion.config.itemSelector), false);
    }
  }

  // First check if there's an accordion instance in the drawer,
  // then check if drawer hasn't been opened once before,
  // finally, check if there are actual accordions to open
  if (this.secondaryAccordion && this.drawerHasOpened === false && this.secondaryAccordion.$accordionContents.length) {
    // If another accordion link has an active class, open it first
    // otherwise, open the first accordion in the drawer
    var _activeItem = this.$nodes.secondaryAccordion.find(this.secondaryAccordion.config.itemLink + '.drawer__item--active');

    if (_activeItem.length) {
      // Open the active accordion with no animation
      this.secondaryAccordion.toggle(_activeItem.closest(this.secondaryAccordion.config.itemSelector), false);
    }
  }

  // Lock scrolling on mobile
  this.$nodes.page.on('touchmove.drawer', function () {
    return false;
  });

  this.$nodes.page.on('click.drawer', function () {
    _this.close();
    return false;
  });

  this.$drawer.prepareTransition();

  this.$nodes.parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
  this.drawerIsOpen = true;
  Config.set('drawerIsOpen', this.drawerIsOpen);

  this.drawerHasOpened = true;

  A11y.prototype.trapFocus(this.$drawer, 'drawer_focus');
  this.$drawer.focus();

  if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
    this.$activeSource.attr('aria-expanded', 'true');
  }
};

/**
 * Close drawer if not already closed
 * @method  close
 * @param {object} [options] optional configuration object
 * @param {boolean} [options.resetFocus=true] whether to reset the focus to the activation source after close
*/
Drawer.prototype.close = function (options) {
  var _this2 = this;

  var config = _Object$assign({ resetFocus: true }, options);

  // don't close a closed drawer
  if (!this.drawerIsOpen) {
    return;
  }

  // deselect any focused form elements
  $(document.activeElement).trigger('blur');

  this.$drawer.addClass('is-transitioning');
  this.$nodes.parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass);

  this.drawerIsOpen = false;
  Config.set('drawerIsOpen', this.drawerIsOpen);

  // Remove setup class, 610 is length of transition. transitionended event
  // can't be used reliably here because of interplay with nav
  setTimeout(function () {
    _this2.$drawer.removeClass('is-transitioning');

    A11y.prototype.removeTrapFocus(_this2.$drawer, 'drawer_focus');
    if (_this2.$activeSource) {
      if (config.resetFocus) {
        _this2.$activeSource.focus();
      }

      if (_this2.$activeSource.attr('aria-expanded')) {
        _this2.$activeSource.attr('aria-expanded', 'false');
      }
    }
  }, 610);

  this.$nodes.page.off('.drawer');
};

/**
 * Close drawer if ESC key pressed
 * @method _onKeyDown
 * @private
 * @param {Event} evt event object returned from event handler
*/
Drawer.prototype._onKeyDown = function (evt) {
  if (this.drawerIsOpen && evt.keyCode === keyCodes.ESCAPE) {
    this.close();
  }
};

/**
 * Event that's run when the drawer is clicked on
 * @method _onClick
 * @private
 * @param {Event} evt event object returned from click event
*/
Drawer.prototype._onClick = function (evt) {
  var baseURI = location.protocol + '//' + location.hostname + (location.port && ':' + location.port) + '/';

  // Close drawer if the URL is linking to the current page
  if (baseURI === evt.target.href) {
    this.close({ resetFocus: false });
  }
};

module.exports = Drawer;
